// app/javascript/projects/components/CodePageContainer.jsx

import React from 'react';

import { useRenameCode } from 'hooks/codes/mutations/useRenameCode';
import { useUpdateCodeSynthesis } from 'hooks/codes/mutations/useUpdateCodeSynthesis';
import { useCodeDetails } from 'hooks/codes/queries';
import { useCodeExcerpts } from 'hooks/excerpts/queries';
import { useProject } from 'hooks/projects/queries';
import { useUser } from 'hooks/users/queries';

import CodePageModal from './CodePageModal'
import { useModal } from './modal/MemoModalProvider';
import { useCodePageModal } from './contexts/CodePageModalContext';

const CodePageContainer = ({ 
  codeID, 
  projectID, 
  hasEditPermission,
  show,
  hideModal,
  codePage = false
}) => {
  // Data fetching hooks
  const { data: code, isLoading: codeLoading } = useCodeDetails(codeID);
  const {
    data: excerptsData,
    isLoading: excerptsLoading
  } = useCodeExcerpts(codeID, { enabled: !!codeID });
  const { data: projectData, isLoading: projectLoading } = useProject(projectID);
  const { data: user, isLoading: userLoading } = useUser(code?.user_id, projectID);
  
  // Use mutation hooks
  const renameCodeMutation = useRenameCode();
  const updateSynthesisMutation = useUpdateCodeSynthesis();
  
  // Convert excerpts data to format expected by CodePageModal  
  const excerpts = excerptsData?.excerptIds || [];
  const transcripts = projectData?.transcripts || [];
  const transcriptCount = transcripts.length;
  
  const loading = codeLoading || excerptsLoading || projectLoading || userLoading;
  const canPage = excerptsData?.hasMore || false;
  
  const saveCodeName = (codeName) => {
    if (codeName && codeID) {
      renameCodeMutation.mutate({
        codeId: codeID,
        name: codeName
      });
    }
  }

  const saveText = (synthesisText) => {
    if (code && code.id) {
      updateSynthesisMutation.mutate({
        codeId: code.id,
        synthesis: synthesisText
      });
    } else if (hideModal) {
      hideModal();
    }
  };

  const { isModalOpen } = useModal();
  const { closeModal } = useCodePageModal();

  return (
    <CodePageModal
      codeID={codeID}
      codePage={!!codePage}
      projectID={projectID}
      excerpts={excerpts}
      transcripts={transcripts}
      code={code || {}}
      show={show}
      transcriptCount={transcriptCount}
      saveText={saveText}
      saveCodeName={saveCodeName}
      hideModal={hideModal || closeModal}
      overlappingCodes={[]}
      canPage={canPage}
      loading={loading}
      hasEditPermission={hasEditPermission}
      user={user}
      isModalOpen={isModalOpen}
    />
  );
}

export default CodePageContainer;
